export class LimiteAdicionais {
  static readonly MAXIMO_POR_TIPO = 10;

  static mensagem(tipo: string): string {
    const descricao = tipo === 'escolha-simples' ? 'escolha simples' : 'múltipla escolha (lista)';
    return `O limite é de 10 adicionais de ${descricao}. Remova um adicional desse tipo antes de continuar.`;
  }

  static obtenhaErro(camposAdicionais: any[] = [], adicional: any = null): string | null {
    const campos = (camposAdicionais || []).filter(campo => !adicional ||
      (campo !== adicional && !(campo.id != null && adicional.id != null && String(campo.id) === String(adicional.id))));
    if(adicional) campos.push(adicional);

    for(const tipo of ['escolha-simples', 'multipla-escolha']) {
      if(campos.filter(campo => campo.tipo === tipo ||
        (tipo === 'multipla-escolha' && campo.tipo === 'componente-kit')).length > this.MAXIMO_POR_TIPO)
        return this.mensagem(tipo);
    }

    return null;
  }
}
